var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "4.63 4.21 99.78 99.76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#215eac",
    fillRule: "evenodd",
    d: "M54.52,4.21C26.96,4.21,4.63,26.54,4.63,54.09s22.34,49.88,49.89,49.88,49.89-22.33,49.89-49.88S82.07,4.21,54.52,4.21m0,94.55c-24.68,0-44.68-20-44.68-44.67S29.84,9.42,54.52,9.42s44.68,20,44.68,44.67-20,44.67-44.68,44.67m23.23-55.4c4.38,8.2,3.94,16.43-.8,24.32-1.99,3.34-4.37,6.48-6.85,9.48-4.73,5.7-9.66,11.24-14.84,17.25-2.09-3.7-4.58-7.24-6.14-11.16-1.76-4.44-.18-8.61,2.93-12.12,2.86-3.21,5.89-6.27,8.65-9.57,4.06-4.87,4.29-8.4,1.09-13.91-2.08-3.58-4.31-7.06-6.51-10.64-2,2.46-4.03,4.97-6.09,7.45-1.84,2.23-3.88,4.31-5.55,6.67-4.67,6.61-4.49,13.74-1.76,20.99,1.03,2.75,2.3,5.42,3.02,8.45-3.51-4.51-7.13-8.95-10.45-13.59-1.75-2.46-3.16-5.21-4.38-7.99-2.78-6.29-2.34-12.57,1.11-18.43,1.81-3.07,4.11-5.91,6.53-8.53,4.87-5.28,10-10.34,14.97-15.52,.81-.84,1.37-1.89,2.03-2.82,.22,.04,.44,0,.5,.09,5.58,6.84,11.22,13.63,16.65,20.58,2.21,2.82,4.22,5.86,5.9,9.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgLogo);
export default __webpack_public_path__ + "static/media/WG-Logo.2d3e3d20738f766053b08b9e85fecdbb.svg";
export { ForwardRef as ReactComponent };